export default {
  uid: "multiLine",
  attributeId: "",
  formId: "",
  pencilDef: {
    title: "Multi Line",
    group: "FIELD",
    handleIcon: "FaAlignLeft",
    styles: {},
  },
  options: {
    title: "Multiline Untitled",
    type: "multiLine",
    required: false,
    limits: {
      min: 10,
      max: 2000,
    },
    rows: 1,
  },
};
